import React, { useState } from 'react';
import './Contact.css';

const CONTACT = {
  primaryEmailLabel: 'Primary Email',
  primaryEmail: 'info@genseqsolutions.co.za',
  workEmailLabel: 'Work Email (Cody)',
  workEmail: 'cody@genseqsolutions.co.za',
  phoneDisplay: '+27 71 576 7534',
  phoneWhatsAppE164: '27715767534', // SA country code 27 + remove leading 0
  // Swap this to Cal.com or Google Appointments later without touching JSX:
  bookingUrl: 'https://calendly.com/genseqsolutions',
  // bookingUrl: 'https://cal.com/genseqsolutions', // <- example if you switch
  // bookingUrl: '<your Google Calendar booking page link>',
};

const Contact = () => {
  const [activeTab, setActiveTab] = useState('email');
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Message sent! We\'ll get back to you soon.');
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <div className="contact-section" id="contact">
      <div className="contact-header">
        <div className="section-subtitle">Connect With Us</div>
        <h2 className="section-title">Contact Hub</h2>
        <div className="title-underline"></div>
        <p className="section-description">
          Reach out for innovative solutions and exceptional service
        </p>
      </div>

      <div className="contact-container">
        {/* Contact Methods Panel */}
        <div className="contact-methods-panel">
          <div className="contact-tabs">
            <button
              className={`contact-tab ${activeTab === 'email' ? 'active' : ''}`}
              onClick={() => setActiveTab('email')}
            >
              <i className="fas fa-envelope"></i> Email
            </button>
            <button
              className={`contact-tab ${activeTab === 'call' ? 'active' : ''}`}
              onClick={() => setActiveTab('call')}
            >
              <i className="fas fa-calendar-check"></i> Book a Call
            </button>
            <button
              className={`contact-tab ${activeTab === 'whatsapp' ? 'active' : ''}`}
              onClick={() => setActiveTab('whatsapp')}
            >
              <i className="fab fa-whatsapp"></i> WhatsApp
            </button>
          </div>

          <div className="method-content">
            {activeTab === 'email' && (
              <div className="method-details fade-in">
                <h3>Email Us</h3>
                <div className="email-options">
                  <a href={`mailto:${CONTACT.primaryEmail}`} className="email-card">
                    <div className="email-icon">
                      <i className="fas fa-envelope"></i>
                    </div>
                    <div className="email-info">
                      <span>{CONTACT.primaryEmailLabel}</span>
                      <p>{CONTACT.primaryEmail}</p>
                    </div>
                  </a>

                  <a href={`mailto:${CONTACT.workEmail}`} className="email-card">
                    <div className="email-icon">
                      <i className="fas fa-envelope-open-text"></i>
                    </div>
                    <div className="email-info">
                      <span>{CONTACT.workEmailLabel}</span>
                      <p>{CONTACT.workEmail}</p>
                    </div>
                  </a>
                </div>
                <p className="response-time">We reply within 24 hours</p>
              </div>
            )}

            {activeTab === 'call' && (
                <div className="method-details fade-in">
                  <div className="coming-soon-wrap">
                    <span className="coming-soon-badge">Coming soon</span>
                  </div>

                  <h3>Bookings</h3>
                  <p>
                    We’re building our own scheduling system. For now, please email us and we’ll lock in a time.
                  </p>

                  <a
                    href={
                      "mailto:info@genseqsolutions.co.za" +
                      "?subject=" + encodeURIComponent("Book a meeting with Genesis Sequence Solutions") +
                      "&body=" + encodeURIComponent(
                        "Hi GSS team,\n\n" +
                        "I’d like to book a meeting.\n\n" +
                        "Name:\n" +
                        "Preferred date(s)/time(s) (GMT+2):\n" +
                        "Meeting type: Video or Phone (+27 71 576 7534)\n" +
                        "Notes:\n\n" +
                        "Thanks!"
                      )
                    }
                    className="email-cta-btn"
                  >
                    <i className="fas fa-paper-plane"></i> Email to Book
                  </a>

                  {/* Keep the cards visible but disabled for now */}
                  <div className="schedule-options disabled">
                    <div className="schedule-card">
                      <i className="fas fa-video"></i>
                      <h4>Video Call</h4>
                      <p>30 min • Google Meet/Zoom</p>
                    </div>
                    <div className="schedule-card">
                      <i className="fas fa-phone"></i>
                      <h4>Phone Call</h4>
                      <p>15 min • Direct conversation</p>
                    </div>
                  </div>
                </div>
              )}

            {activeTab === 'whatsapp' && (
              <div className="method-details fade-in">
                <h3>Chat with Us</h3>
                <p>Message us directly on WhatsApp for quick responses</p>
                <a
                  href={`https://wa.me/${CONTACT.phoneWhatsAppE164}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whatsapp-btn"
                >
                  <i className="fab fa-whatsapp"></i> Start WhatsApp Chat
                </a>
                <div className="contact-info-item">
                  <i className="fas fa-phone-alt"></i>
                  <span>{CONTACT.phoneDisplay}</span>
                </div>
                <p className="availability">Available Monday–Friday, 9AM–5PM GMT+2</p>
              </div>
            )}
          </div>
        </div>

        {/* Contact Form */}
        <div className="contact-form-container">
          <div className="form-header">
            <h3>Send Us a Message</h3>
            <p>We'll get back to you within 24 hours</p>
          </div>

          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                rows="5"
                required
              ></textarea>
            </div>

            <button type="submit" className="submit-btn">
              Send Message <i className="fas fa-paper-plane"></i>
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
